import React from "react";
import { Link, useLocation } from "react-router-dom";
import { APP_VERSION, PORTAL_LOGO_LONG, PORTAL_LOGO_MINI } from "../../utils/constant";
import { ROUTES } from "../../utils/key_helper";
import { useProfileContext } from "../context/ProfileContext";
import { useConfigContext } from "../context/ConfigContext";
import { compactNumberWithTooltip } from "../user-pages/ui-helper";
const Sidebar = () => {
	const { profileData } = useProfileContext();
	const { configData } = useConfigContext();
	const location = useLocation();

	const isPathActive = (path) => {
		return location.pathname.startsWith(path);
	};

	const onRouteChanged = () => {
		document.querySelector("#sidebar").classList.remove("active");
	};

	React.useEffect(() => {
		onRouteChanged();

		// Add hover effect for sidebar icon-only mode
		const body = document.querySelector("body");
		const navItems = document.querySelectorAll(".sidebar .nav-item");

		navItems.forEach((el) => {
			el.addEventListener("mouseover", () => {
				if (body.classList.contains("sidebar-icon-only")) {
					el.classList.add("hover-open");
				}
			});
			el.addEventListener("mouseout", () => {
				if (body.classList.contains("sidebar-icon-only")) {
					el.classList.remove("hover-open");
				}
			});
		});

		return () => {
			navItems.forEach((el) => {
				el.removeEventListener("mouseover", () => { });
				el.removeEventListener("mouseout", () => { });
			});
		};
	}, [location.pathname]);

	return (
		<nav className="sidebar sidebar-offcanvas fixed-sidebar" id="sidebar">
			<div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
				<a className="sidebar-brand brand-logo" >
					<img src={PORTAL_LOGO_LONG} alt="logo" />
				</a>
				<a className="sidebar-brand brand-logo-mini" >
					<img src={PORTAL_LOGO_MINI} alt="logo" />
				</a>
			</div>
			<ul className="nav">
				<li className="nav-item nav-category">
					<span className="nav-link text-muted pb-0">
						User
						<span className="nav-link text-muted ms-2 py-0">
							[ {APP_VERSION} ]
						</span>
					</span>
				</li>
				<li className={isPathActive(ROUTES.DASHBOARD) ? "nav-item menu-items active" : "nav-item menu-items"}>
					<Link className="nav-link" to={ROUTES.DASHBOARD}>
						<span className="menu-icon">
							<i className="mdi mdi-speedometer warning-text"></i>
						</span>
						<span className="menu-title">
							Dashboard
						</span>
					</Link>
				</li>
				<li className={isPathActive(ROUTES.ACCOUNT) ? "nav-item menu-items active" : "nav-item menu-items"}>
					<Link className="nav-link" to={ROUTES.ACCOUNT}>
						<span className="menu-icon">
							<i className="mdi mdi-account-circle primary-text"></i>
						</span>
						<span className="menu-title">
							Account
						</span>
					</Link>
				</li>
				<li className={isPathActive(ROUTES.STRATEGY) ? "nav-item menu-items active" : "nav-item menu-items"}>
					<Link className="nav-link" to={ROUTES.STRATEGY}>
						<span className="menu-icon">
							<i className="mdi mdi-lightbulb-outline info-text"></i>
						</span>
						<span className="menu-title">
							Strategy
						</span>
					</Link>
				</li>
				<li className={isPathActive(ROUTES.MY_STRATEGY) ? "nav-item menu-items active" : "nav-item menu-items"}>
					<Link className="nav-link" to={ROUTES.MY_STRATEGY}>
						<span className="menu-icon">
							<i className="mdi mdi-chart-line warning-text"></i>
						</span>
						<span className="menu-title">
							My Strategy
						</span>
					</Link>
				</li>
				{/* IF custom_bridge_allow OR json_bridge_allow than shows this sidebar options */}
				{(profileData?.custom_bridge_allow || profileData?.json_bridge_allow) && (
					<li className={isPathActive(ROUTES.BRIDGE) ? "nav-item menu-items active" : "nav-item menu-items"}>
						<Link className="nav-link" to={ROUTES.BRIDGE}>
							<span className="menu-icon">
								<i className="mdi mdi-link-variant success-text"></i>
							</span>
							<span className="menu-title">
								TradingView
							</span>
						</Link>
					</li>
				)}
				<li className={isPathActive(ROUTES.ORDER_HISTORY) ? "nav-item menu-items active" : "nav-item menu-items"}>
					<Link className="nav-link" to={ROUTES.ORDER_HISTORY}>
						<span className="menu-icon">
							<i className="mdi mdi-history warning-text"></i>
						</span>
						<span className="menu-title">
							Order History
						</span>
					</Link>
				</li>
				{/* If payment enabled than shows this menu options */}
				{configData?.payment_enabled && (
					<>
						<li className={isPathActive(ROUTES.WALLET) ? "nav-item menu-items active" : "nav-item menu-items"}>
							<Link className="nav-link" to={ROUTES.WALLET}>
								<span className="menu-icon">
									<i className="mdi mdi-wallet info-text"></i>
								</span>
								<span className="menu-title">
									Wallet <span className="success-text">(${compactNumberWithTooltip(profileData?.current_credit, "Current Credit")})</span>

								</span>

							</Link>
						</li>
						<li className={isPathActive(ROUTES.REFERRAL) ? "nav-item menu-items active" : "nav-item menu-items"}>
							<Link className="nav-link" to={ROUTES.REFERRAL}>
								<span className="menu-icon">
									<i className="mdi mdi-share-variant success-text"></i>
								</span>
								<span className="menu-title">
									Referral
								</span>
							</Link>
						</li>
					</>
				)}
				<li className={isPathActive(ROUTES.ACTIVITY_LOGS) ? "nav-item menu-items active" : "nav-item menu-items"}>
					<Link className="nav-link" to={ROUTES.ACTIVITY_LOGS}>
						<span className="menu-icon">
							<i className="mdi mdi-calendar-clock warning-text"></i>
						</span>
						<span className="menu-title">
							Activity Logs
						</span>
					</Link>
				</li>
				<li className={isPathActive(ROUTES.PROFILE) ? "nav-item menu-items active" : "nav-item menu-items"}>
					<Link className="nav-link" to={ROUTES.PROFILE}>
						<span className="menu-icon">
							<i className="mdi mdi-account info-text"></i>
						</span>
						<span className="menu-title">
							Profile
						</span>
					</Link>
				</li>

			</ul>
		</nav >
	);
};

export default Sidebar;
